export default "__VITE_ASSET__B9YeoGe8__"